"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function LogoutIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M23.7,14.654l-3.873-3.873-1.2,1.2,2.422,2.421H7.928v1.7h13.12l-2.422,2.421,1.2,1.2L23.7,15.856a.85.85,0,0,0,0-1.2Z" }),
        react_1.default.createElement("path", { d: "M10.244,5.336l3.4,6.109,1.485-.827L10.987,3.175a.885.885,0,0,0-1.487,0L.158,19.967A.85.85,0,0,0,.9,21.23H16.4v-1.7H2.346Z" })));
}
exports.default = LogoutIcon;
